import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import z from 'zod';
import { useCountDown } from '../../../../hooks/useTimer';
import { RoleChangeDialogSchema } from '../../../../schemas/signInSchemas';
import { sendVerificationCodeToEmail } from '../../../../services/authentication/signup';
import DialogTitle from '../../../Dashboard/DialogTitle';
import PasswordInput from '../../../ui/PasswordInput';
import { IonicButton, IonicInput } from 'ionic-ui';
import useIonicToast from '../../../../hooks/useIonicToast';

export function SecondDialogue({ onCancel }: { onCancel: () => void }) {
  const { counterTime, isCounting, startCountDown, stopCountDown } =
    useCountDown(1);
  const { presentIonToast } = useIonicToast();
  const {
    getValues,
    formState: { errors },
    control,
  } = useFormContext<z.infer<typeof RoleChangeDialogSchema>>();
  const { email, password, token } = getValues();

  // REQUEST NEW TOKEN
  const resendToken = () => {
    if (isCounting || password || !email) return;
    try {
      startCountDown();
      sendVerificationCodeToEmail(email);
    } catch (error: any) {
      presentIonToast(error.message);
      console.error(error.message);
    }
  };

  React.useEffect(() => {
    startCountDown();
    return () => {
      if (isCounting) stopCountDown();
    };
  }, []);

  return (
    <div className="text-center space-y-4">
      {/* <img src="" alt="" className='w-[80%] h-auto' /> */}
      <DialogTitle>Create Store owner account</DialogTitle>
      {/* <h6 className="text-lg text-text-dark-high font-semibold">
      </h6> */}
      <p className="text-sm text-text-dark-medium font-medium">
        {password
          ? 'Enter your password to continue'
          : 'Enter The Token Sent to your email'}
        {!password && (
          <span>
            <IonicButton
              size="sm"
              variant="ghost"
              disabled={isCounting}
              onClick={resendToken}
            >
              {isCounting ? `Resend Token in ${counterTime}` : 'Resend Token'}
            </IonicButton>
          </span>
        )}
      </p>
      <Controller
        control={control}
        name="email"
        render={({ field }) => (
          <IonicInput
            {...field}
            size="xlg"
            readOnly
            aria-readonly="true"
            type="text"
            className="w-full !disabled:opacity-80"
            hint={errors.email?.message}
            hintClass="text-red-600 dark:text-red-600"
          />
        )}
      />
      {password && (
        <Controller
          control={control}
          name="password"
          render={({ field }) => (
            <PasswordInput
              readOnly
              aria-readonly="true"
              {...field}
              size="xlg"
              className="w-full !disabled:opacity-80"
              placeholder="Enter your password"
              hint={errors.password?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
      )}
      {!password && (
        <Controller
          control={control}
          name="token"
          render={({ field }) => (
            <IonicInput
              {...field}
              size="xlg"
              placeholder="Enter your token"
              type="code"
              className="w-full !disabled:opacity-80"
              hint={errors.token?.message}
              hintClass="text-red-600 dark:text-red-600"
            />
          )}
        />
      )}

      <div className="flex items-center gap-4 flex-wrap">
        <IonicButton
          type="submit"
          size="lg"
          disabled={!password && !token}
          className="min-w-fit flex-1"
        >
          Create Account
        </IonicButton>
        <IonicButton
          type="button"
          onClick={onCancel}
          variant="outline"
          size="lg"
          className="min-w-fit flex-1"
        >
          Cancel
        </IonicButton>
      </div>
    </div>
  );
}
